import React from 'react';
import { useIntl } from 'react-intl';
import ContainerWrapper from 'Common/Components/ContainerWrapper';
import { Tabs } from 'Common/Components/Tabs';
import Setup from '../components/Setup';
import Logs from '../components/Logs';

const DatevScreen: React.FC = () => {
  const intl = useIntl();

  return (
    <Tabs
      defaultActiveKey="settings"
      items={[
        {
          key: 'settings',
          label: intl.formatMessage({ defaultMessage: 'Settings' }),
          children: (
            <ContainerWrapper css="padding: 1em 2em">
              <Setup />
            </ContainerWrapper>
          ),
        },
        {
          key: 'logs',
          label: intl.formatMessage({ defaultMessage: 'Log files' }),
          children: (
            <ContainerWrapper css="padding: 1em 2em">
              <Logs />
            </ContainerWrapper>
          ),
        },
      ]}
    />
  );
};

export default DatevScreen;
